import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.VersionHistory', {
    title: 'Workflow versions',
    buttonLoadMoreText: 'Load more',
    version: 'Version',
    by: 'by',
});
